import styled, { css } from "styled-components";

const ChangeMarker = styled.div`
  width: 0;
  height: 0;
  border: 5px solid transparent;
  ${({ change }) =>
    change === "increase" &&
    css`
      border-bottom: 8px solid #4cdd6e;
    `}
  ${({ change }) =>
    change === "decrease" &&
    css`
      border-top: 8px solid #d95d62;
    `}
`;

export default ChangeMarker;
